import { stringify } from 'query-string';
import { MAX_LIMIT } from 'config';

import { sortOrderTypes } from 'types/shared';

// Returns a list of available customers. Customers are
// called DSPs interchangeably throughout Opus.
export default getCustomersURL;

interface ICustomersURLArgs {
  customerIds?: string[];
  feedType?: string[];
  isActive?: boolean;
  nameFilter?: string;
  limit?: number;
  offset?: number;
  sortOrder?: sortOrderTypes;
  sortBy?: string;
}

function getCustomersURL(args: ICustomersURLArgs = {}): string {
  const {
    customerIds,
    feedType,
    isActive = true,
    limit = MAX_LIMIT,
    nameFilter,
    offset,
    sortBy,
    sortOrder,
  } = args;

  const params = stringify({
    customerIds,
    feedType,
    isActive,
    limit,
    nameFilter,
    offset,
    sortBy,
    sortOrder,
  });

  return `/api/customers?${params}`;
}
